module.exports = __webpack_public_path__ + "img/c8.2b092fcf.png";